/**File {
 *  origin_name: string,
 *  mime_type: string
 *  size: number,
 *  data_encrypt: string
 * }
 * Message {
 *  id: string;
 *  code: string;
 *  content: string;
 *  file: File | null;
 *  role: 'user' | 'assistant';
 *  timestamp: number;
 *  show: boolean,
 *  status: boolean,
 ******* 以下assistant角色专属 *******
 *  goodJob: number; // 0: 未操作 1:点赞 2:点踩
 * }
 * state {
 *  messages: Message[];
 *  chatSessionId: string;
 *  isLoading: boolean;
 *  error: string | null;
 * }
 */
const tokenTimeout = 4000; // 重新获取token查询时间限制

export default {
  namespaced: true,
  state: {
    messages: [],
    chatSessionId: '',
    isLoading: false,
    error: null,
  },
  mutations: {
    updateChatSessionId: (state, data) => {
      state.chatSessionId = data;
    },
    addMessage: (state, data) => {
      state.messages = [...state.messages, data];
    },
    reSendUserMessage: (state, {id, newId}) => {
      state.messages.forEach((msg) => {
        if(msg.id === id) {
          msg.id = newId;
          msg.timestamp = Date.now();
          return;
        }
      });
    },
    updateUserMessage: (state, {id, content, status = true}) => {
      state.messages.forEach((msg) => {
        if(msg.id === id) {
          msg.content = content;
          msg.show = true;
          msg.status = status;
          return;
        }
      });
    },
    updateAssistantMessage: (state, {id, content, status = true}) => {
      if (status) {
        state.messages.forEach((msg) => {
          if(msg.id === id) {
            msg.content = content;
            msg.show = true;
            msg.status = status;
            return;
          }
        });
      } else {
        const index = state.messages.findIndex(msg => msg.id == id);
        state.messages.splice(index,1);
      }
    },
    updateChat: (state, {userId, assistantId, code}) => {
      let finish = 0;
      state.messages.forEach((msg) => {
        if (finish >= 2) {
          return;
        }
        if(msg.id === userId) {
          msg.code = code;
          finish++;
        }
        if(msg.id === assistantId) {
          msg.code = code;
          finish++;
        }
      });
    },
    setIsLoading: (state, data) => {
      state.isLoading = data;
    },
    setError: (state, data) => {
      state.error = data;
    },
    clearMessages: (state , data = '') => {
      if (data) {
        state.messages = data;
      } else {
        state.messages = [];
      }
    }
  },
  actions: {
    async setState({dispatch, state}, {}) {
      try {
        await dispatch('setStorage', {name: 'message', message: {messages: state.messages, chatSessionId: state.chatSessionId}}, { root: true});
      } catch (error) {
        throw error;
      }
    },
    async getState({dispatch, commit}, {}) {
      try {
        const res = await dispatch('getStorage', {name: 'message'}, { root: true});
        if (res) {
          if (res.chatSessionId) {
            commit('updateChatSessionId', res.chatSessionId);
          }
          if (res.messages) {
            commit('clearMessages', res.messages);
          }
        }
      } catch (error) {
        throw error;
      }
    },
    async updateChatTag({dispatch, state}, {index, type}) {
      state.messages[index].goodJob = type;
      // 处理App数据转存问题
      await dispatch('setStorage', {name: 'message', message: {messages: state.messages, chatSessionId: state.chatSessionId}}, { root: true});
    },
    sendMessage: async ({commit, dispatch, rootState}, {url, data, onMessage, onError, onComplete, resend = 0}) => {
      const controller = new AbortController();
      const signal = controller.signal;
      try {
        const authToken = rootState.authToken;
        const response = await fetch(process.env.VUE_APP_BASE_API + url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify(data),
          signal,
        })
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const reader = response.body.getReader();
        const headers = response.headers;

        if (!reader) {
          throw new Error('No response body');
        }

        const decoder = new TextDecoder('utf-8');
        let buffer = '';

        const processChunk = async (chunk, first = 0) => {
          if (chunk.done) {
            onComplete({headers: headers});
            return;
          }

          buffer += decoder.decode(chunk.value, {stream: true});
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 摘出末尾拼接、解析报错
          if (first && buffer.trim() !== '' && !buffer.startsWith('data: ')) {
            let obj = '';
            try {
              obj = JSON.parse(buffer);
            } catch (error) {
              throw new Error('异常解析=>' + buffer);
            }
            const Code = obj ? obj.code : '';
            if (obj && Code !== 0) {
              switch (Code) {
                case 401: // token 过期
                case 10110002: // 10110002 token过期已刷新过
                  // 重新获取token
                  if (resend >= 2) {
                    throw new Error('token异常');
                  }
                  const getToken = new Promise((resolve, reject) => {
                    // 调用app壳功能重新获取token,然后重新发送
                    // eslint-disable-next-line
                    uni.webView.postMessage({
                      data: {
                        action: 'resetToken',
                        data: {
                          success: 'resetToken', // 成功回调方法名success(res接口返回序列化字符串)
                          authToken: authToken, // 现有authToken
                          error: 'TokenErr', // 失败回调方法名error(msg<报错信息字符串>)
                        }
                      }
                    });
                    // 等待重置token,超时取消请求抛出错误
                    const timeout = setTimeout(() => {
                      window.resetToken = '';
                      window.TokenErr = '';
                      reject(new Error('亲，网络似乎出了点问题ㄟ( ▔, ▔ )ㄏ'));
                    }, tokenTimeout);
                    window.TokenErr = function (message) {
                      window.resetToken = '';
                      window.TokenErr = '';
                      clearTimeout(timeout);
                      reject(new Error(message));
                    };
                    window.resetToken = function (token) {
                      try {
                        window.resetToken = '';
                        window.TokenErr = '';
                        clearTimeout(timeout);
                        resolve(token);
                      } catch (error) {
                        clearTimeout(timeout);
                        reject(error);
                      }
                    };
                  });
                  getToken
                    .then((token) => {
                      commit('updateAuthToken', token, {root: true});
                      return dispatch('sendMessage', {url, data, onMessage, onError, onComplete, resend: resend + 1});
                    })
                    .catch((err) => {
                      // 如果重置token失败，则传递错误
                      if (err.message.includes('亲，网络')) {
                        return dispatch('sendMessage', {url, data, onMessage, onError, onComplete, resend: resend + 1});
                      } else {
                        throw err;
                      }
                    });
                  break;
                case 10110005:
                case 10110006:
                  uni.webView.postMessage({
                    data: {
                      action: 'reLogin'
                    }
                  });
                  throw new Error('登录异常');
                  break;
                default:
                  throw new Error(obj.msg);
              }
            } else if (obj && Code == 0) {
              const content = obj.data ? obj.data.content : '';
              const message = {
                choices: [{ delta: { content } }]
              };
              onMessage(message, first)
              onComplete({headers: headers});
              return;
            }
          }

          lines.forEach((line) => {
            if (line.trim() === '') return;
            if (line.startsWith('data: ')) {
              const data = line.slice(6);
              if (data === '[DONE]') {
                onComplete({headers: headers});
                return;
              }
              try {
                const message = JSON.parse(data);
                onMessage(message, first);
                if (message.choices && message.choices[0].finish_reason !== null) {
                  onComplete({reason: message.choices[0].finish_reason, headers: headers});
                  return;
                }
              } catch (error) {
                throw new Error('解析错误=>' + data);
              }
            }
          });
          const nextChunk = await reader.read();
          await processChunk(nextChunk);
        };
        const chunk = await reader.read();
        await processChunk(chunk, 1);

        return () => controller.abort();
      } catch (error) {
        controller.abort();
        onError(error);
        throw error;
      }
    }
  }
};